module.exports = __webpack_public_path__ + "media/images/landing/icon-group35-c1897375ca7f51074fffc9c4ae9f9425.svg";